<template>
  <div>
    <div :class="gameImgAreaClass()" v-if="mapList && mapList.length > 0" >
      <div  v-for="(item, index) in mapList" :key="index" :id="getLinesId(index)"
           :class="{ box:true, h_top: gameTopClass(index), h_bottom: gameBottomClass(index) }">
        <img :src="require('../../../assets/'+ gamePath +'/' + item + '.png')" alt="" :class="{ deep: matchDeepColor(index) || matchDeppFreeColor(index) || matchScatterWin(item)}">
      </div>
    </div>
    <div :class="gameImgDetailClass()" v-if="mapListDetail">
      <div class="box" v-for="(item, index) in mapListDetail" :key="index">
        <img :src="require('../../../assets/'+ gamePath  +'/' + item.key + '.png')" alt="" :class="{ deep: true }">
        <p>x {{item.lines}} ({{item.length}})</p>
        <p v-if="item.winInfo !=null">{{item.winInfo}}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import {slots_tool} from "../slots_tool";
  export default
  {
    name: "SlotsDetailLayout",
    props: {
      gamePath:"",
      mapIndex: [],
      mapList: [],
      linesId:"",
      mapListDetail: [],
      isFree: false,
      Phone: false,
      checkFreeColor: false,
      remainFreeCount:3,
      sumRows:3,
      freeId:'S',
      sumColumns:5,
      imgAreaClassId:"",
      imgImgDetailClassId:"",
      checkScatterWin: false,
      scatterWin:false,
      scatterItem:"S",
      mapTopClass:[],
      mapBottomClass:[],
      isCheckTable: false,
      checkTable:  [],
    },
    data() {
      return {

      };
    },
    created() {

    },
    methods: {
      getLinesId(index) {
        return slots_tool.setLineIdName(this.linesId, index)
      },
      gameTopClass(index)
      {
        return slots_tool.checkIncludeIndex(this.mapTopClass,index);
      },
      gameBottomClass(index)
      {
        return slots_tool.checkIncludeIndex(this.mapBottomClass,index);
      },
      gameImgAreaClass() {
        return slots_tool.gameImgAreaClass(this.imgAreaClassId);
      },
      gameImgDetailClass() {
        return slots_tool.gameImgDetailClass(this.imgImgDetailClassId);
      },
      matchDeepColor(index)
      {
        return slots_tool.matchDeepColor(this.mapIndex,index);
      },
      matchScatterWin(item)
      {
        return slots_tool.matchScatterWin(item,this.scatterWin,this.checkScatterWin,this.scatterItem)
      },
      matchDeppFreeColor(index)
      {
        console.log("matchDeppFreeColor");
        if(this.isCheckTable)
        {
          return slots_tool.matchDeppFreeColorTable(this.freeId,
            index,
            this.mapList,
            this.remainFreeCount,
            this.checkFreeColor,
            this.checkTable,
          )
        }
        else
        {
          return slots_tool.matchDeppFreeColor(this.freeId,
            index,
            this.mapList,
            this.remainFreeCount,
            this.checkFreeColor,
            this.sumRows,
            this.sumColumns,
          )
        }

      },
    }
}
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/slots/layout/slots_detail_layout.vue